(function () {
  'use strict';

  /*
   Directive handles the display of the card footer
   Attributes:
   card - The card we're showing the summary of
   default - Some default text to be used if there's no summary
   */
  /* Directives */
  angular.module('wsLrs.directives').directive('wsCardSummary', ['$rootScope', 'wsEventNames', function wsCardButton($rootScope, wsEventNames) {
    return {
      restrict: 'A',
      replace: false,
      scope: {
        card: "=",
        defaultText: "="
      },
      templateUrl: "modules/common/directives/card-summary/card-summary.html",
      link: function link(scope) {
        scope.finalDefault = scope.defaultText;
        scope.$watch('defaultText', function (value) {
          if (value) {
            scope.finalDefault = scope.defaultText;
          }
        });
        if (scope.card && scope.card.id === 'preview') {
          $rootScope.$on(wsEventNames.explorer.change.cardSummary, function (evt, summary) {
            scope.card.summary = summary;
          });
        }
      }
    };
  }]);
})();
